module.exports = __webpack_public_path__ + "static/img/technology-4-Support-img-1-cn.f848193.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology-4-Support-img-1-cn.jpg
// module id = BU0T
// module chunks = 0